import { PropsWithChildren, ReactNode } from 'react';

interface Props extends PropsWithChildren {
  wrapper: (children: ReactNode) => JSX.Element;
  when: boolean;
}

export function ConditionalWrapper({ wrapper, children, when }: Props) {
  if (when) {
    return wrapper(children);
  }

  return children;
}
